"use strict";

exports.__esModule = true;
exports.ignoreSsrWarning = void 0;
var ignoreSsrWarning = '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';
exports.ignoreSsrWarning = ignoreSsrWarning;